import { defineStore, createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

export const useCustom = defineStore("custom", {
  state: () => ({
    sliderEnabled: false,
    animationEnabled: false,
    professionalEnabled: false,
  }),
  persist: true,

  actions: {
    toggleAnimation(newValue: boolean) {
      this.animationEnabled = newValue;
    },
    toggleSlider(newValue: boolean) {
      this.sliderEnabled = newValue;
    },
    toggleProfessional(newValue: boolean) {
      this.professionalEnabled = newValue;
    },
  },
});
